import { ComponentPropsWithoutRef } from 'react';

import { cn } from '~/shared/utils/cn';

type ContentBoxProps = ComponentPropsWithoutRef<'div'> & {
  noBorder?: boolean;
  greyBackground?: boolean;
  noPadding?: boolean;
};

export const ContentBoxComponent = ({
  noBorder,
  greyBackground,
  noPadding,
  className,
  ...props
}: ContentBoxProps) => (
  <div
    className={cn(
      'flex w-full flex-col rounded border border-solid border-[#D2D2D2] bg-white p-4',
      noBorder && 'border-none',
      greyBackground && 'bg-[#F5F5F5]',
      noPadding && 'p-0',
      className,
    )}
    {...props}
  />
);
